<template>
  <div class="app-container">
    <list ref="list">
        
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="操作" fixed="right" align="center" width="80">
                <template slot-scope="{row}">
                    <!-- <el-button v-if="$permission.canRead()" type="text" @click="open(row)">查看</el-button> -->
                    <el-button v-if="$permission.canRead()" type="text" @click="open2(row)">查看</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog"></edit-dialog>
    <progress-dialog ref="progressDialog"></progress-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/clothmanagement/progress/list'
import editDialog from '@/components/production/clothmanagement/progress/editDialog'
import progressDialog from '@/components/production/clothmanagement/progress/progressDialog'

export default {
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    progressDialog
  },
  methods: {
    open(row){
      this.$refs.editDialog.open().then(that => {
        that.setData({OrderProductId: row.OrderProductId})
      })
    },
    open2(row){
      this.$refs.progressDialog.open().then(that => {
        that.setData({OrderProductId: row.OrderProductId})
      })
    }
  }
};
</script>